// Содержимое ячейки таблицы: в правке — авто-растущая textarea без рамок, в
// read-only — текст. Поля ячейки и вертикальное центрирование — на самой `td`
// (`TABLE_CELL_CLASS`), здесь только текст.
import type { CSSProperties } from 'react'
import { blockTheme, cn } from '@teach/ui'
import { autoGrowTextArea } from './autoGrowTextArea'

const db = blockTheme.designBlock

interface Props {
  editable: boolean
  value: string
  placeholder: string
  className: string
  color: string
  onChange: (value: string) => void
  onFocus: () => void
}

export const TableCellContent = ({
  editable,
  value,
  placeholder,
  className,
  color,
  onChange,
  onFocus,
}: Props) => {
  if (editable) {
    return (
      <textarea
        value={value}
        rows={1}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onInput={(e) => autoGrowTextArea(e.currentTarget)}
        ref={(el) => autoGrowTextArea(el)}
        onFocus={onFocus}
        onClick={(e) => e.stopPropagation()}
        className={cn(
          className,
          'block w-full resize-none overflow-hidden border-none bg-transparent p-0 outline-none',
          'placeholder:text-[color:var(--tbl-ph)]',
        )}
        style={{ color, '--tbl-ph': db.tablePlaceholder } as CSSProperties}
      />
    )
  }
  // Пробелы и переносы по краям обрезаем: пустая строка над текстом сдвигает его
  // из центра ячейки. Прочерк пустой ячейки — цветом плейсхолдера макета, и
  // ставится ПОСЛЕ языкового фолбэка (непереведённая ячейка покажет русский).
  const text = value.trim()
  return (
    <span
      className={cn(className, 'block whitespace-pre-wrap break-words')}
      style={{ color: text ? color : db.tablePlaceholder }}
    >
      {text || '—'}
    </span>
  )
}
